import { useParams } from "react-router-dom";
import { useSite } from "@/lib/i18n";
import { useSeo } from "@/lib/analytics";

const TITLES = { privacy: "Política de privacidad", terms: "Términos y condiciones", commercial: "Condiciones comerciales", legal_info: "Información legal" };

export default function LegalPage() {
  const { doc } = useParams();
  const { site } = useSite();
  const title = TITLES[doc] || "Documento legal";
  useSeo({ title });
  return (
    <section className="wrap max-w-3xl py-16 md:py-24">
      <p className="eyebrow">Legal</p>
      <h1 className="mt-4 text-4xl font-extrabold tracking-tight" data-testid="legal-title">{title}</h1>
      <div className="mt-8 space-y-4 leading-relaxed text-slate-700 whitespace-pre-line" data-testid="legal-body">{site.legal?.[doc] || "Documento no disponible."}</div>
    </section>
  );
}
